(() => {
  const root = document.getElementById('cap-home-fitment-search');
  if (!root || root.dataset.loaded === 'true') return;
  root.dataset.loaded = 'true';

  const SUPABASE_URL = 'https://vumyshrwjivysgplsgrf.supabase.co';
  const SUPABASE_KEY = 'sb_publishable_wDS4N9-_DV-SAFTaSsgTPg_kRDTuYYk';
  const FIND_PARTS_URL = '/pages/find-parts';
  const LIMITS = { groups:5, makes:10, models:10, parts:10 };

  const form = root.querySelector('.cap-home-fitment__form');
  const status = root.querySelector('.cap-home-fitment__status');
  const submit = root.querySelector('.cap-home-fitment__submit');
  const addVehicle = root.querySelector('.cap-home-fitment__add-vehicle');
  const reset = root.querySelector('.cap-home-fitment__reset');
  const groupsRoot = root.querySelector('[data-vehicle-groups]');
  const partField = root.querySelector('.cap-home-fitment__field--part');
  const tabs = Array.from(root.querySelectorAll('[data-mode-tab]'));
  const clean = value => String(value || '').replace(/\s+/g, ' ').trim();
  const norm = value => clean(value).toLowerCase();
  const wait = milliseconds => new Promise(resolve => window.setTimeout(resolve, milliseconds));

  let groupSequence = 0;
  const newGroup = () => ({ id:++groupSequence, year:'', makes:[], models:[] });
  const state = {
    mode:'parts',
    isSalesRep:String(root.dataset.salesRep || '').toLowerCase() === 'true',
    groups:[newGroup()],
    partTerms:[],
    suggestionCache:new Map(),
    suggestionRequests:new WeakMap()
  };

  async function rpc(name, payload, signal) {
    const response = await fetch(`${SUPABASE_URL}/rest/v1/rpc/${name}`, {
      method:'POST',
      headers:{ apikey:SUPABASE_KEY, Authorization:`Bearer ${SUPABASE_KEY}`, 'Content-Type':'application/json' },
      body:JSON.stringify(payload || {}),
      signal
    });
    if (!response.ok) {
      const error = new Error(`${name} failed: ${response.status} ${await response.text()}`);
      error.status = response.status;
      throw error;
    }
    return response.json();
  }

  async function rpcWithRetry(name, payload, signal) {
    let lastError;
    const guard = window.__capRequestCircuitV1;
    for (const delay of [0, 450, 1200]) {
      if (signal?.aborted) throw new DOMException('The request was aborted.', 'AbortError');
      if (delay) await wait(delay);
      if (signal?.aborted) throw new DOMException('The request was aborted.', 'AbortError');
      try {
        const request = () => rpc(name, payload, signal);
        return await (guard ? guard.run(request, signal) : request());
      }
      catch(error) {
        if (error?.name === 'AbortError' || error?.name === 'CapCircuitOpen') throw error;
        lastError = error;
      }
    }
    throw lastError || new Error(`${name} failed.`);
  }

  async function loadSalesRepMode() {
    try {
      const response = await fetch('/cart.js', { headers:{ Accept:'application/json' }, cache:'no-store' });
      if (!response.ok) throw new Error(`Cart lookup failed: ${response.status}`);
      const cart = await response.json();
      state.isSalesRep = String(cart?.attributes?.sales_rep || '').toLowerCase() === 'true';
      root.dataset.salesRep = state.isSalesRep ? 'true' : 'false';
    } catch(error) {
      console.error('Sales representative mode lookup failed.', error);
    }
  }

  function setStatus(message) {
    status.innerHTML = message || '';
  }

  function hasCriterion(group) {
    return Boolean(clean(group?.year) || group?.makes?.length || group?.models?.length);
  }

  function isComplete(group) {
    return Boolean(clean(group?.year) && group?.makes?.length && group?.models?.length);
  }

  function groupPayloads() {
    return state.groups.filter(hasCriterion).map(group => ({
      year:clean(group.year) || null,
      makes:[...group.makes],
      models:[...group.models]
    }));
  }

  function groupElements() {
    return Array.from(groupsRoot.querySelectorAll('[data-vehicle-group]'));
  }

  function groupForField(field) {
    const element = field.closest('[data-vehicle-group]');
    return element ? state.groups[Number(element.dataset.groupIndex || 0)] : null;
  }

  function selectedValues(field) {
    const type = field.dataset.combo;
    if (type === 'part') return state.partTerms;
    const group = groupForField(field);
    if (!group) return [];
    if (type === 'year') return group.year ? [group.year] : [];
    return type === 'make' ? group.makes : group.models;
  }

  function closeMenus(exceptField) {
    root.querySelectorAll('.cap-home-fitment__field[data-combo]').forEach(field => {
      if (field !== exceptField) field.classList.remove('is-open');
    });
  }

  function renderChips(field) {
    const container = field.querySelector('[data-selection-chips]');
    if (!container) return;
    const type = field.dataset.combo;
    container.replaceChildren();
    selectedValues(field).forEach(value => {
      const chip = document.createElement('span');
      chip.className = 'cap-home-fitment__selection-chip';
      const label = document.createElement('span');
      label.textContent = value;
      const remove = document.createElement('button');
      remove.type = 'button';
      remove.textContent = '×';
      remove.setAttribute('aria-label', `Remove ${value} from ${type}`);
      remove.addEventListener('click', () => removeSelection(field, value));
      chip.append(label, remove);
      container.appendChild(chip);
    });
  }

  function renderAllChips() {
    root.querySelectorAll('.cap-home-fitment__field[data-combo]').forEach(renderChips);
  }

  function removeSelection(field, value) {
    const type = field.dataset.combo;
    const group = groupForField(field);
    if (type === 'part') state.partTerms = state.partTerms.filter(item => norm(item) !== norm(value));
    if (group && type === 'year') {
      group.year = '';
      if (!state.isSalesRep) { group.makes = []; group.models = []; }
    }
    if (group && type === 'make') {
      group.makes = group.makes.filter(item => norm(item) !== norm(value));
      if (!state.isSalesRep && !group.makes.length) group.models = [];
    }
    if (group && type === 'model') group.models = group.models.filter(item => norm(item) !== norm(value));
    const input = field.querySelector('input');
    if (input) input.value = '';
    field.classList.remove('is-open');
    renderAllChips();
    setDisabled();
  }

  function fieldCanOpen(field) {
    const input = field?.querySelector('input');
    return Boolean(input && !input.disabled && !(field.dataset.combo === 'part' && state.mode !== 'parts'));
  }

  function suggestionPayload(field) {
    const group = groupForField(field);
    return {
      p_field:field.dataset.combo,
      p_query:clean(field.querySelector('input')?.value) || null,
      p_year:group?.year ? Number(group.year) : null,
      p_makes:group ? group.makes : [],
      p_models:group ? group.models : [],
      p_vehicle_groups:groupPayloads(),
      p_limit:100
    };
  }

  function normalizeSuggestions(field, rows) {
    const chosen = new Set(selectedValues(field).map(norm));
    return (Array.isArray(rows) ? rows : []).map(row => {
      const value = clean(row?.value || row?.label || row?.year || row?.make || row?.model || row?.part_name);
      return { value, label:clean(row?.label || value), count:Number(row?.available_count || 0) };
    }).filter(option => option.value && !chosen.has(norm(option.value)));
  }

  function cachedFallbackOptions(field, payload) {
    const fallbackPayload = { ...payload, p_query:null };
    const rows = state.suggestionCache.get(JSON.stringify(fallbackPayload)) || [];
    const query = norm(payload.p_query);
    const options = normalizeSuggestions(field, rows);
    return query
      ? options.filter(option => norm(`${option.value} ${option.label}`).includes(query))
      : options;
  }

  function loadSuggestionRows(field, payload, cacheKey, force) {
    const current = state.suggestionRequests.get(field);
    if (current && (force || current.cacheKey !== cacheKey)) current.controller.abort();
    if (!force && current?.cacheKey === cacheKey && !current.controller.signal.aborted) return current.promise;
    if (!force && state.suggestionCache.has(cacheKey)) return Promise.resolve(state.suggestionCache.get(cacheKey));

    const controller = new AbortController();
    const promise = rpcWithRetry('rpc_storefront_dropdown_suggestions_v1', payload, controller.signal)
      .then(rows => {
        state.suggestionCache.set(cacheKey, rows);
        return rows;
      })
      .finally(() => {
        if (state.suggestionRequests.get(field)?.promise === promise) state.suggestionRequests.delete(field);
      });
    state.suggestionRequests.set(field, { cacheKey, controller, promise });
    return promise;
  }

  function renderMenu(field, options, message) {
    const menu = field.querySelector('.cap-home-fitment__menu');
    if (!menu) return;
    menu.replaceChildren();
    if (message || !options.length) {
      const empty = document.createElement('div');
      empty.className = 'cap-home-fitment__empty';
      empty.textContent = message || 'No matching options.';
      menu.appendChild(empty);
    }
    options.forEach(option => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'cap-home-fitment__option';
      button.dataset.optionValue = option.value;
      const label = document.createElement('span');
      label.textContent = option.label;
      button.appendChild(label);
      if (option.count > 0) {
        const count = document.createElement('small');
        count.textContent = `${option.count} match${option.count === 1 ? '' : 'es'}`;
        button.appendChild(count);
      }
      button.addEventListener('mousedown', event => {
        event.preventDefault();
        chooseSuggestion(field, option.value);
      });
      menu.appendChild(button);
    });
    field.classList.add('is-open');
  }

  function keepMultiSelectMenuOpen(field, value) {
    const input = field.querySelector('input');
    if (field.dataset.combo === 'year' || !fieldCanOpen(field)) {
      field.classList.remove('is-open');
      return;
    }
    const menu = field.querySelector('.cap-home-fitment__menu');
    menu?.querySelectorAll('.cap-home-fitment__option').forEach(option => {
      if (norm(option.dataset.optionValue) === norm(value)) option.remove();
    });
    if (menu && !menu.querySelector('.cap-home-fitment__option')) {
      const empty = document.createElement('div');
      empty.className = 'cap-home-fitment__empty';
      empty.textContent = 'No more matching options.';
      menu.appendChild(empty);
    }
    field.classList.add('is-open');
    if (input && document.activeElement !== input) input.focus({ preventScroll:true });
  }

  async function requestSuggestions(field, options = {}) {
    if (!fieldCanOpen(field)) return [];
    const payload = suggestionPayload(field);
    const cacheKey = JSON.stringify(payload);
    const open = options.open !== false;
    const requestId = Number(field.dataset.suggestionRequest || 0) + 1;
    field.dataset.suggestionRequest = String(requestId);
    if (open) renderMenu(field, [], `Loading ${field.dataset.combo} options...`);
    try {
      const rows = await loadSuggestionRows(field, payload, cacheKey, Boolean(options.force));
      if (Number(field.dataset.suggestionRequest) !== requestId) return [];
      const normalized = normalizeSuggestions(field, rows);
      if (open && document.activeElement === field.querySelector('input')) renderMenu(field, normalized);
      return normalized;
    } catch(error) {
      if (Number(field.dataset.suggestionRequest) !== requestId || error?.name === 'AbortError') return [];
      console.error('Suggestion lookup failed.', error);
      const fallback = cachedFallbackOptions(field, payload);
      if (fallback.length) {
        if (open && document.activeElement === field.querySelector('input')) renderMenu(field, fallback);
        return fallback;
      }
      const input = field.querySelector('input');
      const canRender = field.isConnected && document.activeElement === input;
      if (open && canRender) {
        renderMenu(field, [], 'Options are temporarily unavailable.');
        const retry = document.createElement('button');
        retry.type = 'button';
        retry.className = 'cap-home-fitment__option';
        retry.textContent = 'Retry loading options';
        retry.addEventListener('mousedown', event => {
          event.preventDefault();
          void requestSuggestions(field, { open:true, force:true });
        });
        field.querySelector('.cap-home-fitment__menu')?.appendChild(retry);
        setStatus('Catalog options are temporarily unavailable. Retry the open field.');
      }
      return [];
    }
  }

  function chooseSuggestion(field, value) {
    const type = field.dataset.combo;
    const group = groupForField(field);
    const existing = selectedValues(field);
    const limit = type === 'year' ? 1 : LIMITS[type === 'part' ? 'parts' : `${type}s`];
    if (existing.some(item => norm(item) === norm(value))) return;
    if (type !== 'year' && existing.length >= limit) {
      setStatus(`${type === 'part' ? 'Parts' : type} is limited to ${limit} selection${limit === 1 ? '' : 's'}.`);
      return;
    }

    if (type === 'part') state.partTerms.push(value);
    if (group && type === 'year') {
      const changed = group.year && norm(group.year) !== norm(value);
      group.year = value;
      if (changed && !state.isSalesRep) { group.makes = []; group.models = []; }
    }
    if (group && type === 'make') group.makes.push(value);
    if (group && type === 'model') group.models.push(value);

    const input = field.querySelector('input');
    if (input) input.value = '';
    renderAllChips();
    setDisabled();
    keepMultiSelectMenuOpen(field, value);

    if (state.isSalesRep) {
      setStatus(state.mode === 'vehicle'
        ? 'Add up to five vehicle groups, or search all vehicles.'
        : 'Add vehicle criteria and/or part terms, then search.');
    } else if (state.groups.every(isComplete)) {
      setStatus(state.mode === 'parts'
        ? 'Search all matching parts, add part terms, or add another vehicle.'
        : 'Ready to search. You can also add another vehicle.');
    } else if (type === 'year') setStatus('Select one or more makes.');
    else if (type === 'make') setStatus('Select one or more models.');

    const groupElement = field.closest('[data-vehicle-group]');
    if (type === 'year') {
      const next = groupElement?.querySelector('[data-combo="make"]');
      if (fieldCanOpen(next)) void requestSuggestions(next, { open:false });
    }
    if (type === 'make') {
      const next = groupElement?.querySelector('[data-combo="model"]');
      if (fieldCanOpen(next)) void requestSuggestions(next, { open:false });
    }
    if (type === 'model' && fieldCanOpen(partField)) void requestSuggestions(partField, { open:false });
  }

  function setDisabled() {
    root.classList.toggle('has-multiple-vehicles', state.groups.length > 1);
    groupElements().forEach((element, index) => {
      const group = state.groups[index];
      const year = element.querySelector('[data-combo="year"] input');
      const make = element.querySelector('[data-combo="make"] input');
      const model = element.querySelector('[data-combo="model"] input');
      if (year) year.disabled = false;
      if (make) make.disabled = group.makes.length >= LIMITS.makes || (!state.isSalesRep && !clean(group.year));
      if (model) model.disabled = group.models.length >= LIMITS.models || (!state.isSalesRep && !(clean(group.year) && group.makes.length));
      const remove = element.querySelector('.cap-home-fitment__remove-vehicle');
      if (remove) remove.hidden = state.groups.length === 1;
    });

    const customerComplete = state.groups.length > 0 && state.groups.every(isComplete);
    const anyVehicle = state.groups.some(hasCriterion);
    const partInput = partField?.querySelector('input');
    if (partInput) partInput.disabled = state.mode !== 'parts' || (!state.isSalesRep && !customerComplete) || state.partTerms.length >= LIMITS.parts;
    const last = state.groups[state.groups.length - 1];
    if (addVehicle) {
      addVehicle.disabled = state.groups.length >= LIMITS.groups || (state.isSalesRep ? !hasCriterion(last) : !isComplete(last));
      addVehicle.textContent = state.groups.length >= LIMITS.groups ? '5 Max' : 'Add Vehicle';
    }
    submit.disabled = state.isSalesRep
      ? (state.mode === 'parts' && !(anyVehicle || state.partTerms.length))
      : !customerComplete;
  }

  function bindField(field) {
    if (!field || field.dataset.multiBound === 'true') return;
    field.dataset.multiBound = 'true';
    const input = field.querySelector('input');
    if (!input) return;
    let timer = 0;
    input.addEventListener('focus', () => {
      if (!fieldCanOpen(field)) return;
      closeMenus(field);
      void requestSuggestions(field, { open:true });
    });
    input.addEventListener('input', () => {
      window.clearTimeout(timer);
      state.suggestionRequests.get(field)?.controller.abort();
      closeMenus(field);
      timer = window.setTimeout(() => void requestSuggestions(field, { open:true }), 220);
    });
    input.addEventListener('keydown', event => {
      if (event.key === 'Escape') field.classList.remove('is-open');
      if (event.key === 'Enter') {
        event.preventDefault();
        if (!submit.disabled) submit.click();
      }
    });
    input.addEventListener('blur', () => {
      window.setTimeout(() => {
        if (field.contains(document.activeElement)) return;
        if (clean(input.value)) {
          input.value = '';
          setStatus('Choose an option from the dropdown to add it.');
        }
        field.classList.remove('is-open');
      }, 140);
    });
  }

  function prepareGroup(element, index) {
    const group = state.groups[index];
    element.dataset.groupIndex = String(index);
    const heading = element.querySelector('.cap-home-fitment__vehicle-group-head strong');
    if (heading) heading.textContent = `Vehicle ${index + 1}`;
    const remove = element.querySelector('.cap-home-fitment__remove-vehicle');
    if (remove) {
      remove.setAttribute('aria-label', `Remove Vehicle ${index + 1}`);
      if (remove.dataset.bound !== 'true') {
        remove.dataset.bound = 'true';
        remove.addEventListener('click', () => removeGroup(Number(element.dataset.groupIndex || 0)));
      }
    }
    element.querySelectorAll('.cap-home-fitment__field[data-combo]').forEach(field => {
      const type = field.dataset.combo;
      const input = field.querySelector('input');
      const label = field.querySelector('label');
      if (input) {
        input.id = `cap-home-${type}-g${group.id}`;
        input.setAttribute('aria-label', `Vehicle ${index + 1} ${type}`);
      }
      if (label && input) label.setAttribute('for', input.id);
      bindField(field);
    });
  }

  function reindexGroups() {
    groupElements().forEach(prepareGroup);
    renderAllChips();
    setDisabled();
  }

  function addGroup() {
    if (!addVehicle || addVehicle.disabled || state.groups.length >= LIMITS.groups) return;
    const source = groupElements()[0];
    if (!source) return;
    const clone = source.cloneNode(true);
    clone.querySelectorAll('input').forEach(input => { input.value = ''; input.removeAttribute('aria-busy'); });
    clone.querySelectorAll('[data-selection-chips],.cap-home-fitment__menu').forEach(container => container.replaceChildren());
    clone.querySelectorAll('.cap-home-fitment__field').forEach(field => { field.classList.remove('is-open'); delete field.dataset.multiBound; delete field.dataset.suggestionRequest; });
    const remove = clone.querySelector('.cap-home-fitment__remove-vehicle');
    if (remove) delete remove.dataset.bound;
    state.groups.push(newGroup());
    groupsRoot.appendChild(clone);
    reindexGroups();
    setStatus(state.isSalesRep
      ? `Vehicle ${state.groups.length} added. Add any year, make, or model criteria.`
      : `Start Vehicle ${state.groups.length} by selecting a year.`);
    clone.querySelector('[data-combo="year"] input')?.focus();
  }

  function removeGroup(index) {
    if (state.groups.length <= 1 || index < 0 || index >= state.groups.length) return;
    state.groups.splice(index, 1);
    groupElements()[index]?.remove();
    reindexGroups();
    setStatus(`Vehicle ${index + 1} removed.`);
  }

  function resetSearch() {
    const first = groupElements()[0];
    groupElements().slice(1).forEach(element => element.remove());
    state.groups = [newGroup()];
    state.partTerms = [];
    root.querySelectorAll('.cap-home-fitment__field[data-combo]').forEach(field => {
      field.classList.remove('is-open');
      const input = field.querySelector('input');
      if (input) input.value = '';
      field.querySelector('[data-selection-chips]')?.replaceChildren();
      field.querySelector('.cap-home-fitment__menu')?.replaceChildren();
    });
    if (first) prepareGroup(first, 0);
    reindexGroups();
    setStatus(state.isSalesRep
      ? (state.mode === 'vehicle' ? 'Search all vehicles, or add up to five vehicle groups.' : 'Add vehicle criteria and/or part terms, then search.')
      : 'Start by selecting a year.');
  }

  function setMode(mode) {
    state.mode = mode === 'vehicle' ? 'vehicle' : 'parts';
    root.dataset.mode = state.mode;
    tabs.forEach(tab => {
      const active = tab.dataset.modeTab === state.mode;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    submit.textContent = state.mode === 'parts' ? 'Search Parts' : 'Search Vehicles';
    closeMenus();
    setDisabled();
    setStatus(state.isSalesRep
      ? (state.mode === 'vehicle' ? 'Search all vehicles, or add up to five vehicle groups.' : 'Add vehicle criteria and/or part terms, then search.')
      : (state.groups.every(isComplete) ? 'Ready to search or add another vehicle.' : 'Start by selecting a year.'));
  }

  function buildSearchUrl() {
    const query = new URLSearchParams();
    query.set('mode', state.mode);
    groupPayloads().forEach((group, index) => {
      const suffix = index === 0 ? '' : `_${index + 1}`;
      if (group.year) query.set(`year${suffix}`, group.year);
      group.makes.forEach(value => query.append(`make${suffix}`, value));
      group.models.forEach(value => query.append(`model${suffix}`, value));
    });
    if (state.mode === 'parts') state.partTerms.forEach(value => query.append('part', value));
    return `${FIND_PARTS_URL}?${query.toString()}`;
  }

  tabs.forEach(tab => tab.addEventListener('click', () => setMode(tab.dataset.modeTab)));
  addVehicle?.addEventListener('click', addGroup);
  reset?.addEventListener('click', resetSearch);
  bindField(partField);
  groupElements().forEach(prepareGroup);

  document.addEventListener('mousedown', event => {
    root.querySelectorAll('.cap-home-fitment__field[data-combo]').forEach(field => {
      if (field.contains(event.target)) return;
      const input = field.querySelector('input');
      if (input && clean(input.value)) input.value = '';
      field.classList.remove('is-open');
    });
  }, true);

  form.addEventListener('submit', event => {
    event.preventDefault();
    closeMenus();
    root.querySelectorAll('.cap-home-fitment__field[data-combo] input').forEach(input => { input.value = ''; });
    const customerComplete = state.groups.length > 0 && state.groups.every(isComplete);
    const canSearch = state.isSalesRep
      ? (state.mode === 'vehicle' || state.groups.some(hasCriterion) || state.partTerms.length > 0)
      : customerComplete;
    if (!canSearch) {
      setStatus(state.isSalesRep
        ? 'Add a vehicle criterion or part term before searching parts.'
        : 'Complete Year, Make, and Model for every vehicle group.');
      setDisabled();
      return;
    }
    window.location.assign(buildSearchUrl());
  });

  async function init() {
    setMode(state.mode);
    reindexGroups();
    await loadSalesRepMode();
    setMode(state.mode);
    reindexGroups();

    const first = groupElements()[0];
    const prefetch = [first?.querySelector('[data-combo="year"]')];
    if (state.isSalesRep) {
      prefetch.push(first?.querySelector('[data-combo="make"]'));
      prefetch.push(first?.querySelector('[data-combo="model"]'));
    }
    prefetch.filter(Boolean).forEach(field => void requestSuggestions(field, { open:false }));
  }

  init();
})();
